// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__wUnGx","label":"Labeled_label__2yxRX","divider":"Labeled_divider__2xN9e"};